var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.8;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7474.915 -2236.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5593.009,3131.53h-18.524v-11.967a.492.492,0,1,0-.983,0v12.459a.492.492,0,0,0,.492.492h19.016a.492.492,0,1,0,0-.984Z",
    transform: "translate(1901.414 -879.826)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5589.951,3126.859a.491.491,0,0,0-.671-.06l-4.59,3.606a.492.492,0,1,0,.608.773l4.226-3.32,2.316,2.6a.489.489,0,0,0,.346.165.482.482,0,0,0,.359-.134l5.072-4.79v1.482a.492.492,0,0,0,.984,0v-2.623a.488.488,0,0,0-.029-.16c0-.006,0-.011-.005-.017a.494.494,0,0,0-.1-.153s0,0,0-.007l0,0a.494.494,0,0,0-.151-.107l-.008,0a.48.48,0,0,0-.171-.039h-2.647a.492.492,0,0,0,0,.984h1.386l-4.634,4.376Z",
    transform: "translate(1894.02 -883.186)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/Performance.f954cd0c1bdb4b5a3acadcfa58257feb.svg";
export { ForwardRef as ReactComponent };